<template>
  <div class="custom-loader">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
    <strong class="mt-1">{{ label }}</strong>
  </div>
</template>

<script>
  export default {
    name: 'LoadingSpinner',
    props: {
      label: {
        type: String,
        default: 'Loading', // Default label text
      },
    },
  };</script>

<style scoped>
  .custom-loader {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    color: #043d75
  }

  .fa-spin {
    animation-duration: var(--fa-animation-duration, 1s);
  }
</style>